import { useRoute } from '@react-navigation/native';
import { useCallback, useMemo } from 'react';
import { isWeb } from 'src/utils/platform';
import { isSeoCrawler } from 'src/utils/seo/isSeoCrawler';
import { omitSeoParamsFromSearchParams } from 'src/utils/seo/seoOmitParams';
import { DEFAULT_LIST_PAGE_SIZE, pageNoFromOffset, parseLimit, parseOffset, } from './listPagination';
import { resolvePaginationFromRoute } from './routeListPagination';
function buildSeoPageUrlFromLocation(targetOffset, targetLimit) {
    const url = new URL(window.location.href);
    omitSeoParamsFromSearchParams(url.searchParams);
    const offset = parseOffset(targetOffset);
    const limit = parseLimit(targetLimit);
    if (offset <= 0) {
        url.searchParams.delete('offset');
        url.searchParams.delete('limit');
    }
    else {
        url.searchParams.set('offset', String(offset));
        url.searchParams.set('limit', String(limit));
    }
    return url.pathname + url.search;
}
function buildPageUrlFromLocation(targetOffset, targetLimit) {
    if (!isWeb || typeof window === 'undefined') {
        return '';
    }
    if (isSeoCrawler) {
        return buildSeoPageUrlFromLocation(targetOffset, targetLimit);
    }
    const url = new URL(window.location.href);
    const offset = parseOffset(targetOffset);
    const limit = parseLimit(targetLimit);
    if (offset <= 0) {
        url.searchParams.delete('offset');
        url.searchParams.delete('limit');
    }
    else {
        url.searchParams.set('offset', String(offset));
        url.searchParams.set('limit', String(limit));
    }
    return url.pathname + url.search;
}
export default function usePaginationState(options) {
    const enabled = options?.enabled !== false;
    const defaultLimit = options?.defaultLimit ?? DEFAULT_LIST_PAGE_SIZE;
    const route = useRoute();
    const routeParams = route.params;
    const pagination = useMemo(() => enabled
        ? resolvePaginationFromRoute(routeParams, defaultLimit)
        : { offset: 0, limit: defaultLimit }, [enabled, routeParams, defaultLimit]);
    const { offset, limit } = pagination;
    const pageNo = useMemo(() => pageNoFromOffset(offset, limit), [offset, limit]);
    const buildPageTo = useCallback(targetOffset => {
        const nextOffset = parseOffset(targetOffset);
        return {
            screen: route.name,
            params: {
                ...(routeParams ?? {}),
                offset: nextOffset <= 0 ? undefined : nextOffset,
                limit: nextOffset <= 0 ? undefined : limit,
            },
        };
    }, [route.name, routeParams, limit]);
    const buildPageUrl = useCallback(targetOffset => buildPageUrlFromLocation(targetOffset, limit), [limit]);
    return {
        offset,
        limit,
        pageNo,
        hasPrev: offset > 0,
        buildPageTo,
        buildPageUrl,
    };
}
